'use client';

import { useState, useEffect } from 'react';
import Header from '@/components/common/Header';
import HeroSection from './HeroSection';
import MissionSection from './MissionSection';
import VisionSection from './VisionSection';
import OriginStorySection from './OriginStorySection';
import CoreValuesSection from './CoreValuesSection';
import TeamSection from './TeamSection';
import TimelineSection from './TimelineSection';

export default function AboutContent() {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  if (!isHydrated) {
    return (
      <div className="min-h-screen bg-background">
        <Header />
        <main className="pt-16">
          <div className="animate-pulse">
            <div className="h-96 bg-muted" />
            <div className="max-w-7xl mx-auto px-4 py-16 space-y-8">
              <div className="h-8 bg-muted rounded w-1/3" />
              <div className="h-4 bg-muted rounded w-2/3" />
              <div className="h-4 bg-muted rounded w-1/2" />
            </div>
          </div>
        </main>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="pt-16">
        <HeroSection />
        <MissionSection />
        <VisionSection />
        <OriginStorySection />
        <CoreValuesSection />
        <TeamSection />
        <TimelineSection />
      </main>
    </div>
  );
}